import {Form, message} from 'antd';
import axios from 'axios';
import React, {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {useSelector} from 'react-redux';
import {useHistory, useRouteMatch} from 'react-router';
import ActionBar from '../../../../components/action-bar';
import ActionButton from '../../../../components/action-button';
import useDispatchWithResult from '../../../../hooks/useDispatchWithResult';
import {cabecalhoSelector, fetchBeneficiariosSocio, fetchCBEs, fetchCCEs, fetchDEFs, fetchRDEIEDs, fetchRepresentantes, fetchSocios} from '../../../../store/empresa';
import unwrapAxiosPromise from '../../../../util/unwrapAxiosPromise';
import EmpresaSocioForm from './_form';
import useModulo from "../../../../hooks/useModulo";

export default function EmpresaSocioCreatePage() {
  const {t} = useTranslation();
  const dispatch = useDispatchWithResult();
  const [form] = Form.useForm();
  const cabecalho = useSelector(cabecalhoSelector);
  const [loadingSave, setLoadingSave] = useState(false);
  const history = useHistory();
  const match = useRouteMatch();
  const empresaId = match.params.empresaId;
  const {moduloBasePath} = useModulo();

  useEffect(() => {
    form.resetFields();
    setImmediate(() => document.querySelector('#documento').focus());
  }, []);

  const handleFinish = values => {
    setLoadingSave(true);
    unwrapAxiosPromise(axios.post(`/empresas/${empresaId}/socios`, values), form)
        .then(data => {
          message.success(t('Registro incluído com sucesso'));
          history.replace(`${moduloBasePath}/empresas/${empresaId}/socios`);
          dispatch(fetchSocios({empresaId}));
          dispatch(fetchRepresentantes({empresaId}));
          dispatch(fetchBeneficiariosSocio({empresaId}));
          dispatch(fetchRDEIEDs({empresaId}));
          dispatch(fetchDEFs({empresaId}));
          dispatch(fetchCCEs({empresaId}));
          dispatch(fetchCBEs({empresaId}));
        })
        .finally(() => setLoadingSave(false));
  };

  const handleCancel = () => {
    history.replace(`${moduloBasePath}/empresas/${empresaId}/socios`);
  };

  const title = (
      <ActionBar>
        <ActionButton.Save onClick={form.submit} loading={loadingSave} />
        <ActionButton.Cancel onClick={handleCancel} disabled={loadingSave} />
      </ActionBar>);

  return (
      <EmpresaSocioForm
          disabled={loadingSave}
          cabecalho={cabecalho}
          form={form}
          onFinish={handleFinish}
          title={title}
      />);
}
